



































import { Vue, Component } from 'vue-property-decorator';
import { getList } from '../api';

@Component
export default class Home extends Vue {
  data: any = [];
  async created() {
    const workType = [1, 2];
    const ret = await Promise.all(
      workType.map((item) => {
        return getList({
          work_type: item,
        });
      }),
    );
    this.data = ret.map((item) => item.data);
  }
  onNavTo(item: any) {
    this.$router.push(`detail?id=${item.id}`);
  }
}
